import "./presence.scss";

export const PRESENCE_STATUS_LABELS = {
    Online: "Online",
    Away: "Away",
    Busy: "Busy",
    OutOfOffice: "Out Of Office",
    Offline: "Offline",
};

const STATUS_COLORS = {
    Online: "#27D639",
    Away: "#F5A623",
    Busy: "#FF0101",
    OutOfOffice: "#A855F7",
    Offline: "#B0B4BA",
};

const PresenceDot = ({ status, className = "" }) => {
    if (!status || !STATUS_COLORS[status]) return null;

    return (
        <span
            className={`presenceDot ${className}`}
            style={{ backgroundColor: STATUS_COLORS[status] }}
            title={status}
        />
    );
};

export default PresenceDot;
